/* ==========================================================================
   OBD/SS Classic -> Ride Height Simulators upsell
   Loaded only on the Classic product page (see classic-rhs-upsell.liquid).

   Flow:
   1. Shopper clicks "Add to Cart" for the Classic.
   2. We intercept the CLICK in the capture phase on `window` -- this runs
      BEFORE the theme's own add handler, so nothing is added and the cart
      drawer does NOT open yet.
   3. If the cart already contains a Ride Height Simulators variant, we skip
      the modal and just let the Classic add normally.
   4. Otherwise the modal asks about vehicle height:
        - "No, keeping stock height."  -> add ONLY the Classic (native add)
        - "Add to Cart" (x4 or x2 RHS) -> AJAX-add the RHS, then native-add the
          Classic so the drawer opens/refreshes showing both items.

   The final Classic add is handed back to the theme by re-clicking the
   original button, so it works whether Horizon adds on click or on submit.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.__RHS_UPSELL;
  if (!CFG || window.__RHS_UPSELL_BOUND) return;
  window.__RHS_UPSELL_BOUND = true;

  var ROOT = CFG.rootUrl || '/';
  var CLASSIC_VARIANTS = (CFG.classicVariantIds || []).map(String);
  var RHS_IDS = [String(CFG.rhsX4), String(CFG.rhsX2)];

  var modal, backdrop, addBtn, declineBtn, closeBtn, pills;
  var selectedVariant = String(CFG.rhsX4);
  var pendingForm = null;
  var pendingBtn = null;
  var open = false;

  /* --- wire up UI once DOM is ready ------------------------------------ */
  ready(function () {
    modal = document.getElementById('rhsu-modal');
    if (!modal) return;

    // Lift the modal to the top of <body> and above the cart drawer.
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.style.zIndex = '2147483647';

    backdrop   = document.getElementById('rhsu-backdrop');
    addBtn     = document.getElementById('rhsu-add');
    declineBtn = document.getElementById('rhsu-decline');
    closeBtn   = document.getElementById('rhsu-close');
    pills      = Array.prototype.slice.call(document.querySelectorAll('#rhsu-options .rhsu-pill'));

    if (closeBtn) closeBtn.addEventListener('click', cancel);
    if (backdrop) backdrop.addEventListener('click', cancel);
    document.addEventListener('keydown', function (e) {
      if (open && e.key === 'Escape') cancel();
    });

    // Pill selection.
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () { selectPill(pill); });
    });
    var active = pills.filter(function (p) { return p.classList.contains('rhsu-pill--active'); })[0] || pills[0];
    if (active) selectPill(active);

    // Stock height: add only the Classic.
    if (declineBtn) declineBtn.addEventListener('click', handBackToTheme);

    // Modified height: RHS required -> add RHS, then add the Classic.
    if (addBtn) addBtn.addEventListener('click', function () {
      addBtn.disabled = true;
      addRHS(selectedVariant)
        .then(handBackToTheme)
        .catch(function (err) {
          addBtn.disabled = false;
          console.error('[RHS Upsell] failed to add Ride Height Simulators:', err);
          window.alert('Sorry, something went wrong adding the Ride Height Simulators. Please try again.');
        });
    });
  });

  /* --- intercept the Classic add CLICK (capture, on window) ------------- */
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var form = t.closest('form[action*="/cart/add"]');
    if (!form) return;

    var btn = t.closest('button, input[type="submit"], input[type="button"]');
    if (!btn || !form.contains(btn)) return;

    var name = (btn.getAttribute('name') || '').toLowerCase();
    var type = (btn.getAttribute('type') || '').toLowerCase();
    if (name !== 'add' && type !== 'submit') return; // ignore qty +/- etc.

    // Our own re-click / re-submit passes straight through to the theme.
    if (btn.__rhsuBypass) { btn.__rhsuBypass = false; return; }

    if (!isClassicForm(form)) return;

    e.preventDefault();
    e.stopImmediatePropagation();   // beat the theme's add handler
    pendingForm = form;
    pendingBtn = btn;
    decideAndShow();
  }, true);

  /* --- also catch keyboard Enter submits (no click) -------------------- */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.__rhsuBypass) { form.__rhsuBypass = false; return; }
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!isClassicForm(form)) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    pendingForm = form;
    pendingBtn = null;
    decideAndShow();
  }, true);

  /* --- decide: skip if RHS already in cart, else show modal ------------ */
  function decideAndShow() {
    cartHasRHS().then(function (has) {
      if (has) handBackToTheme();  // already covered -> just add the Classic
      else showModal();
    });
  }

  /* --- pills ----------------------------------------------------------- */
  function selectPill(pill) {
    selectedVariant = pill.getAttribute('data-variant');
    pills.forEach(function (p) {
      var on = p === pill;
      p.classList.toggle('rhsu-pill--active', on);
      p.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    updateImage();
  }

  function updateImage() {
    var img = document.getElementById('rhsu-img');
    if (!img) return;
    var data = (CFG.rhsImages || {})[selectedVariant];
    if (data && data.src) {
      img.removeAttribute('srcset');
      img.src = data.src;
      if (data.w) img.width = data.w;
      if (data.h) img.height = data.h;
    }
  }

  /* --- helpers --------------------------------------------------------- */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function isClassicForm(form) {
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput ? String(idInput.value) : '';
    return CLASSIC_VARIANTS.indexOf(variantId) !== -1;
  }

  function cartHasRHS() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = (cart.items || []).map(function (i) { return String(i.variant_id); });
        return RHS_IDS.some(function (id) { return inCart.indexOf(id) !== -1; });
      })
      .catch(function () { return false; }); // on error, show the modal
  }

  function showModal() {
    if (!modal) return;
    open = true;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function hideModal() {
    if (!modal) return;
    open = false;
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  // X / backdrop / Esc = cancel; nothing gets added.
  function cancel() {
    hideModal();
    if (addBtn) addBtn.disabled = false;
    pendingForm = null;
    pendingBtn = null;
  }

  function addRHS(variantId) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }

  // Re-fire the original add so the theme adds the Classic and opens the drawer.
  function handBackToTheme() {
    var form = pendingForm, btn = pendingBtn;
    hideModal();
    pendingForm = null;
    pendingBtn = null;
    if (addBtn) addBtn.disabled = false;

    if (btn) {
      if (form) form.__rhsuBypass = true;   // in case the click also submits
      btn.__rhsuBypass = true;
      btn.click();
      setTimeout(function () {               // clean up any unused flags
        btn.__rhsuBypass = false;
        if (form) form.__rhsuBypass = false;
      }, 0);
    } else if (form) {
      form.__rhsuBypass = true;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }
})();